import getMailboxJunkEmailConfiguration from '../services/getMailboxJunkEmailConfiguration';
import setMailboxJunkEmailConfiguration from '../services/setMailboxJunkEmailConfiguration';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyAddToSpamList, SpamScenarioId } from 'owa-spam-row-option';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { orchestrator } from 'satcheljs';
import {
    addMailboxToSafeSenders,
    addMailboxToTrustedSendersList,
} from '../actions/actionCreators/addToSafeSenders';

/**
 * Fetches the junkEmailConfiguration, adds the mailbox to the end of trustedSendersAndDomains, and updates
 * the userConfiguration option locally and on the server
 */
orchestrator(addMailboxToSafeSenders, async actionMessage => {
    const confirmResponse = await confirm(
        format(strings.safeSendersTitle, actionMessage.mailbox.EmailAddress),
        format(strings.safeSendersSubtext, actionMessage.mailbox.EmailAddress)
    );
    if (confirmResponse === DialogResponse.ok) {
        const junkMailConfiguration = await getMailboxJunkEmailConfiguration();

        addMailboxToTrustedSendersList(actionMessage.mailbox, junkMailConfiguration);
        setMailboxJunkEmailConfiguration(junkMailConfiguration);

        if (isFeatureEnabled('tri-spamV2SenderDomain')) {
            lazyAddToSpamList.importAndExecute(
                SpamScenarioId.SafeSendersAndDomains,
                actionMessage.mailbox.EmailAddress,
                -1
            );
        }
    }
});
